import {
  Box,
  IconButton,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  useDisclosure,
} from 'design-system';
import { FiImage } from 'react-icons/fi';

export interface IFamilyPhotoCell {
  imageUrl?: string | null;
  // 'icon' (default) renders the table's ghost icon button; 'thumb' renders a
  // 44px image thumbnail for the mobile card list. Both open the same preview
  // modal on tap.
  variant?: 'icon' | 'thumb';
}

export const FamilyPhotoCell = ({ imageUrl, variant = 'icon' }: IFamilyPhotoCell) => {
  const preview = useDisclosure();

  if (!imageUrl) {
    if (variant === 'thumb') {
      return (
        <Box
          boxSize='44px'
          borderRadius='10px'
          bg='gray.100'
          color='gray.300'
          fontSize='18px'
          display='flex'
          alignItems='center'
          justifyContent='center'
          flexShrink={0}>
          <FiImage />
        </Box>
      );
    }
    return (
      <Box color='gray.300' fontSize='16px' px='2'>
        <FiImage />
      </Box>
    );
  }

  return (
    <>
      {variant === 'thumb' ? (
        <Box as='button' type='button' aria-label='View photo' flexShrink={0} onClick={preview.onOpen}>
          <Image src={imageUrl} alt='family' boxSize='44px' borderRadius='10px' objectFit='cover' />
        </Box>
      ) : (
        <IconButton aria-label='View photo' size='sm' variant='ghost' icon={<FiImage />} onClick={preview.onOpen} />
      )}
      <Modal isOpen={preview.isOpen} onClose={preview.onClose} size={{ base: 'full', md: 'xl' }} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody display='flex' justifyContent='center' alignItems='center' p='6'>
            <Image src={imageUrl} alt='family' maxH='70vh' objectFit='contain' />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
